package pt.at.oss.kotlin.core.i18n

/**
 * Translations for the generic AT table component
 */
enum class AtTableI18n(override val translations: Map<PageLocale, String>) : I18nBase {

    TABLE_ROWS_PER_PAGE(mapOf(PageLocale.PT to "Elementos por página")),
    SEARCH_FILTER(mapOf(PageLocale.PT to "Filtrar por ")),
    SEARCH_PLACEHOLDER(mapOf(PageLocale.PT to "Qualquer palavra")),

    NUMBER_OF_RESULTS(mapOf(PageLocale.PT to "N.º de Resultados")),
    NUMBER_OF_RESULTS_MESSAGE_NO_RESULTS(mapOf(PageLocale.PT to "Nenhum resultado.")),
    ;
}
